import "./description.scss";
import { TypographyKeys } from "@/theme/typography";
import { ColorKeys, createColorClasses } from "@/theme/colors";
import clsx from "clsx";
import { PropsWithChildren } from "react";

type DescriptionProps = PropsWithChildren<{
  fs?: TypographyKeys;
  color?: ColorKeys;
  className?: string;
}>;

export const Description = ({
  fs = "6",
  color = "slate-28",
  className,
  children,
}: DescriptionProps) => {
  const createFontSizeClass = (size: TypographyKeys) => {
    return `fs-${size}`;
  };

  const fontSizeClass = createFontSizeClass(fs);

  const textColorClass = createColorClasses({ text: color });

  return (
    <div
      className={clsx(
        fontSizeClass,
        textColorClass,
        "fw-regular",
        "ui-max-width-section-description",
        "md-fs-custom",
        "description-rich-text",
        className,
      )}
    >
      {children}
    </div>
  );
};
